export default "__VITE_ASSET__CVxlkJXU__"